module.exports = __webpack_public_path__ + "static/nate-846afbb1347c3f47d0d91026a25f8daa.jpg";